import { Flex } from "@chakra-ui/react";
import { Section } from "components/section";
import React from "react";
import { TextTitle } from "ui/text";
import { pricingDetails, pricingExtensions } from "./data";
import { DetailCard, ExtensionCard } from "./detail-cards";

export function PricingDetails() {
  return (
    <Section>
      <TextTitle
        size="lg"
        align="center"
        mobileAlign="center"
        title="Features included in Customer Data Platform and AI Decisioning Plans"
      />
      <Flex
        flexDir="column"
        gap="small"
        mt={{ base: "biggest", lg: "huge" }}
        maxW={{ base: "600px", lg: "100%" }}
        mx="auto"
      >
        {pricingDetails.map((detail) => (
          <DetailCard key={detail.title} {...detail} />
        ))}
        <ExtensionCard {...pricingExtensions} />
      </Flex>
    </Section>
  );
}
